import { cn } from "@/lib/utils"
import { useTheme } from "@/components/theme-provider"

export function AuthCard({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-2xl border border-border/40 bg-card/70 p-7 shadow-2xl shadow-black/20 backdrop-blur-xl dark:bg-card/60",
        className,
      )}
    >
      {children}
    </div>
  )
}

export function AuthHeading({
  eyebrow,
  title,
  description,
}: {
  eyebrow?: string
  title: string
  description: string
}) {
  return (
    <div className="space-y-2">
      {eyebrow && (
        <div className="text-2xs font-semibold uppercase tracking-[0.22em] text-rose-400/80">
          {eyebrow}
        </div>
      )}
      <h1 className="text-2xl font-semibold tracking-tight text-foreground">
        {title}
      </h1>
      <p className="text-sm leading-relaxed text-muted-foreground">
        {description}
      </p>
    </div>
  )
}

export function LogoMark() {
  const { resolvedTheme } = useTheme()
  const src = resolvedTheme === "light" ? "/logo-light.svg" : "/logo.svg"
  return (
    <div className="mb-7 flex items-center justify-start">
      <img
        src={src}
        alt="Hivehook"
        className="h-7 w-auto select-none opacity-90"
        draggable={false}
      />
    </div>
  )
}
